export function Disclaimer() {
  return (
    <div className="rounded-xl bg-blue-50 p-4">
      <p className="text-xs text-gray-950">
        <span className="font-semibold">Disclaimer:</span> The coverage details below assume this
        policy is used as if it is the only coverage in place. If multiple policies are shown, each
        is modeled independently and not combined together. While you may use this policy alongside
        other coverages in practice, Waterlily can only model combined coverage with self-funding or
        annuity options.
      </p>
    </div>
  );
}
